import React, { useState } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller, Control } from "react-hook-form";
import { isValid, format, parse } from "date-fns";

type DatePickerProps = {
  name: string;
  control: Control<any>;
  maxDateToday?: boolean;
  isMobile?: boolean;
  allowTyping?: boolean;
  defaultDate?: Date;
};

const DatePickerCustom: React.FC<DatePickerProps> = ({
  name,
  control,
  maxDateToday,
  isMobile,
  allowTyping,
}) => {
  const strToDate = (s?: string | null) => {
    if (!s) return null;
    const d = parse(s, "yyyy/MM/dd", new Date());
    return isValid(d) ? d : null;
  };

  const dateToStr = (d?: Date | null) =>
    d && isValid(d) ? format(d, "yyyy/MM/dd") : "";

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        const valueAsDate = strToDate(field.value);

        return (
          <DatePicker
            value={valueAsDate}
            onChange={(newVal: Date | null) => {
              // ✅ cho phép clear nếu cần
              field.onChange(newVal ? dateToStr(newVal) : "");
            }}
            reduceAnimations
            maxDate={maxDateToday ? new Date() : undefined}
            slotProps={{
              popper: { disablePortal: true },
              openPickerButton: { color: "success" },
              field: {
                openPickerButtonPosition: "start",
                // ✅ cấm gõ nhưng không phá focus/mousedown
                readOnly: !allowTyping,
              },
              textField: {
                fullWidth: true,
                placeholder: "dd/mm/yyyy",
                variant: "outlined",
                size: "small",
                sx: {
                  "& .MuiPickersOutlinedInput-root": {
                    padding: isMobile ? "0.3rem 15px" : "1px 15px",
                    fontSize: "14px",
                    borderRadius: isMobile ? 3 : 1,
                    "& fieldset": { borderColor: "#d1d5db" },
                    "&.Mui-focused:not(.Mui-error) .MuiPickersOutlinedInput-notchedOutline":
                      { borderColor: "#16A34A" },
                  },
                },
              },
            }}
          />
        );
      }}
    />
  );
};
export default DatePickerCustom;
